module.exports = __webpack_public_path__ + "img/phone-ic.adfaf172.svg";